var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51396 6.43037L14.3809 0H12.9712L8.80932 5.49922L4.64702 0H0L6.48559 8.56916L1.61821 15H3.02793L7.19024 9.50031L11.353 15H16L9.51396 6.43037ZM2.29162 1.16564H4.1192L13.7079 13.8343H11.8804L2.29162 1.16564Z",
    fill: "#F0F0F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.05c1daa6baa5137033ef7b3f630e667f.svg";
export { ForwardRef as ReactComponent };